import React, { useState, useEffect } from "react";
import "./index.scss";
import FormGenerator from "../../../../core/form-generator";
import { getServiceInfoFormConfig } from "./config";
import { Box, Grid, IconButton } from "@mui/material";
import {
  getFileNameFromUrl,
  handleFormValidation,
  PAGE_LIMIT,
} from "../../../../utils";
import SiAutocomplete from "../../../../core/si-autocomplete";
import SiFileUpload from "../../../../core/file-uploader";
import CustomButtonComponent from "../../../../core/custom-button";
import {
  HTTP_METHODS,
  invokeApi,
  plainApi,
} from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import InputWithAction from "./input-with-action";
import PlantDetails from "./plant-details";
import SiTextField from "../../../../core/si-textfield";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { toast } from "react-toastify";
const CreateServiceInformation = ({ setIsCreate, loadData, editData }) => {
  const [formData, setFormData] = useState({
    engineModel: [],
  });
  const [errors, setErrors] = useState({});
  const [oemsList, setOemsList] = useState([]);
  const [files, setFiles] = useState([]);
  const [approverList, setApproverList] = useState([]);
  const [engineModelList, setEngineModelList] = useState([]);
  const [listNumbers, setListNumber] = useState([]);
  const [defectCodeList, setDefectCodeList] = useState([]);
  const [plantDetails, setPlantDetails] = useState([]);
  const [addPlant, setAddPlant] = useState(false);
  let oemTimeout = null;

  const submitHandler = () => {
    const isValid = handleFormValidation(
      getServiceInfoFormConfig(),
      setErrors,
      formData
    );
    if (engineModelList.length < 1) {
      toast.error("Enter Engine Models");
      return;
    }
    if (listNumbers?.length < 1) {
      toast.error("Enter List Numbers");
      return;
    }
    if (isValid) {
      const payload = {
        ...formData,
        oem: formData?.oem?.value,
        engineModel: engineModelList,
        listNumbers: listNumbers,
        plantDetails: plantDetails,
        attachments: files?.map((file) => file.url || file) || [],
        approvedBy: formData.approvedBy?.value,
        defectCode: formData.defectCode?.value,
      };
      if (editData?.id) {
        invokeApi(
          HTTP_METHODS.PUT,
          `${HOSTNAME}${REST_URLS.SERVICE_INFORMATION}/${editData.id}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Service Info Updated Successfully");
              setIsCreate(false);
              loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
            }
          })
          .catch((err) => console.error(err));
      } else {
        invokeApi(
          HTTP_METHODS.POST,
          `${HOSTNAME}${REST_URLS.SERVICE_INFORMATION}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Service Info Created Successfully");
              setIsCreate(false);
              loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };
  const loadDefectCodes = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.GET_CODES}`, null, {
      type: "defect",
      page: 1,
      limit: 1000,
    })
      .then((response) => {
        if (response.results) {
          const codeList = response.results.map((ele) => ({
            label: `${ele.code}-${ele.description}`,
            value: ele.id,
          }));
          setDefectCodeList(codeList);
        }
      })
      .catch((err) => console.error(err));
  };
  const callBack = (newFile) => {
    setFiles([...files, newFile]);
  };
  const getOemList = (filters) => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, null, {
      ...filters,
    })
      .then((response) => {
        if (response) {
          const result = response.map((ele) => ({
            label: ele.name,
            value: ele.id,
          }));
          setOemsList(result);
        }
      })
      .catch((err) => console.error(err));
  };
  const onDelete = (index) => {
    files.splice(index, 1);
    setFiles([...files]);
  };
  const savePlant = (newPlant) => {
    setPlantDetails([...plantDetails, newPlant]);
    setAddPlant(false);
  };
  const onPlantDelete = (index) => {
    plantDetails.splice(index, 1);
    setPlantDetails([...plantDetails]);
  };
  const getApproverList = () => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.APPROVER_LIST}`)
      .then((res) => {
        if (res.message) {
          toast.error("Approvers not found");
        } else {
          const result = res.map((ele) => ({ label: ele.name, value: ele.id }));
          setApproverList(result);
        }
      })
      .catch((err) => console.error(err));
  };
  const handleRegexSearch = (newInputValue) => {
    clearTimeout(oemTimeout);
    if (newInputValue) {
      oemTimeout = setTimeout(() => getOemList(newInputValue), 300);
    }
  };
  useEffect(() => {
    getOemList();
    getApproverList();
    loadDefectCodes();
  }, []);
  useEffect(() => {
    if (editData?.id) {
      const {
        siNumber,
        oem,
        releaseDate,
        subject,
        engineModel,
        listNumbers,
        plantDetails,
        attachments,
        defectCode,
      } = editData;
      setFormData((prevVal) => ({
        ...prevVal,
        siNumber,
        oem: oemsList?.find((ele) => ele?.value === oem?.id),
        releaseDate,
        subject,
        defectCode: defectCodeList?.find(
          (ele) => ele?.value === defectCode?.id
        ),
      }));
      setEngineModelList(engineModel);
      setFiles(attachments);
      setListNumber(listNumbers);
      const updatedPlantDetails = plantDetails?.map((ele) => ({
        plantName: ele.plantName,
        cutInDate: ele?.cutInDate?.split("T")[0],
        cutInNumber: ele?.cutInNumber,
      }));
      setPlantDetails(updatedPlantDetails);
    }
  }, [oemsList, defectCodeList]);

  return (
    <div>
      <div className="form-con" style={{ width: "100%" }}>
        <FormGenerator
          config={getServiceInfoFormConfig(oemsList, defectCodeList)}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
        />
        <Grid
          container
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Grid item md={5.8}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
              }}
            >
              <div
                style={{ width: engineModelList?.length > 0 ? "48%" : "100%" }}
              >
                <p>Engine Model</p>
                <InputWithAction
                  updateStateFun={setEngineModelList}
                  stateValue={engineModelList}
                  placeholder="Enter Engine Model"
                />
              </div>
              {engineModelList?.length > 0 && (
                <div className="input-field-con">
                  {engineModelList?.map((engine, index) => {
                    return (
                      <div
                        className={`chip-com-con purple-bg`}
                        style={{ width: "fit-content", marginRight: "10px " }}
                      >
                        <p>{engine} </p>
                        <CloseOutlinedIcon
                          onClick={() => {
                            const filteredList = engineModelList?.filter(
                              (ele) => ele !== engine
                            );
                            setEngineModelList(filteredList);
                          }}
                          fontSize="small"
                          sx={{ ml: 1, cursor: "pointer" }}
                        />
                      </div>
                    );
                  })}
                </div>
              )}
            </Box>

            <div>
              <p>Subject</p>
              <SiTextField
                placeholder="Subject"
                value={formData?.subject || ""}
                onChange={(e) => {
                  setFormData((preVal) => ({
                    ...preVal,
                    subject: e?.target?.value,
                  }));
                }}
              />
            </div>
          </Grid>
          <Grid item md={5.8} sx={{ mr: 3 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
              }}
            >
              <div
                style={{ width: engineModelList?.length > 0 ? "48%" : "100%" }}
              >
                <p>List Numbers</p>
                <InputWithAction
                  updateStateFun={setListNumber}
                  stateValue={listNumbers}
                  placeholder="Enter List Number"
                />
              </div>
              {listNumbers?.length > 0 && (
                <div className="input-field-con">
                  {listNumbers?.map((list, index) => {
                    return (
                      <div
                        className={`chip-com-con purple-bg`}
                        style={{ width: "fit-content", marginRight: "10px " }}
                      >
                        <p>{list} </p>
                        <CloseOutlinedIcon
                          onClick={() => {
                            const filteredList = listNumbers?.filter(
                              (ele) => ele !== list
                            );
                            setListNumber(filteredList);
                          }}
                          fontSize="small"
                          sx={{ ml: 1, cursor: "pointer" }}
                        />
                      </div>
                    );
                  })}
                </div>
              )}
            </Box>
            <PlantDetails
              plantList={plantDetails}
              handleClose={() => setAddPlant(false)}
              onSave={savePlant}
              onDelete={onPlantDelete}
            />
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            mb: 2,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <SiFileUpload id={null} callBack={callBack} />
        </Box>
        {files?.map((r, index) => {
          return (
            <div key={r.blobName + index}>
              {r.blobName ? (
                <span>{r.blobName}</span>
              ) : (
                <a href={r} target="_blank">
                  {getFileNameFromUrl(r)}
                </a>
              )}

              <IconButton onClick={() => onDelete(index)}>
                <CancelOutlinedIcon />
              </IconButton>
            </div>
          );
        })}
      </div>
      <div className="form-con" style={{ width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            mr: 2,
            mb: 3,
          }}
        >
          <div>
            <p>Approver Name</p>
            <SiAutocomplete
              options={approverList}
              value={formData.approvedBy || ""}
              onChange={(value) =>
                setFormData((prevVal) => ({
                  ...prevVal,
                  approvedBy: value,
                }))
              }
              sx={{ width: "300px" }}
              placeholder="Select Approver"
            />
          </div>
          <CustomButtonComponent
            variant="contained"
            color="primary"
            sx={{ width: "200px" }}
            disabled={!formData.approvedBy}
            onClick={submitHandler}
          >
            Submit for Approval
          </CustomButtonComponent>
        </Box>
      </div>
    </div>
  );
};

export default CreateServiceInformation;
